import API_CONNECT from '../_Connection/ApiConfig';
import "../../../App/Assets/Styles/App/Core/Security/AdminActionVerification.css";
import { REACT_HOT_TOAST_SUCCESS } from '../../../_Helpers/Helpers/reactHotToast.helper';

const REQUEST_URL = '/auth/admin-action-verification/request';
const VERIFY_URL = '/auth/admin-action-verification/verify';

let activePromise = null;

const isProtectedResource = (resource = '') => {
    const path = String(resource || '');
    if (!path) return false;
    if (path.includes('/public/')) return false;
    if (path.includes('/portal/')) return false;
    if (path.includes('/auth/')) return false;


    return true;
};

const actionLabel = (method, resource) => {
    const verb = String(method || '').toUpperCase();
    const path = String(resource || '').toLowerCase();
    if (verb === 'DELETE') return 'eliminar definitivamente este registro';
    if (path.includes('/archive')) return 'archivar este registro';
    if (path.includes('/restore')) return 'restaurar este registro';
    if (verb === 'PUT' || verb === 'PATCH') return 'guardar estos cambios';
    return 'confirmar esta acción';
};

const normalizedError = (error, fallback) => {
    const body = error?.response?.data || {};
    return body?.message || body?.detail || error?.message || fallback;
};

const removeExisting = () => {
    document.querySelectorAll('.SDAdminVerifyOverlay').forEach((node) => node.remove());
};

const createModal = ({ recipient, action, onVerify, onResend, onCancel }) => {
    removeExisting();
    const overlay = document.createElement('div');
    overlay.className = 'SDAdminVerifyOverlay';
    overlay.innerHTML = `
        <section class="SDAdminVerifyModal" role="dialog" aria-modal="true" aria-labelledby="sd-admin-verify-title">
            <header class="SDAdminVerifyModal__header">
                <div>
                    <span class="SDAdminVerifyModal__eyebrow">SEGURIDAD</span>
                    <h2 id="sd-admin-verify-title">Confirmá la acción</h2>
                    <p>Antes de ${action}, ingresá el código que enviamos al correo del administrador.</p>
                </div>
                <button type="button" class="SDAdminVerifyModal__close" aria-label="Cerrar">×</button>
            </header>
            <div class="SDAdminVerifyModal__body">
                <div class="SDAdminVerifyModal__notice">
                    <strong>Código enviado</strong>
                    <span>${recipient || 'correo del administrador'}</span>
                </div>
                <label class="SDAdminVerifyModal__field">
                    <span>Código de verificación</span>
                    <input inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" aria-describedby="sd-admin-verify-error" />
                </label>
                <div id="sd-admin-verify-error" class="SDAdminVerifyModal__error" aria-live="polite"></div>
                <p class="SDAdminVerifyModal__help">El código vence en pocos minutos y sirve solamente para esta acción.</p>
            </div>
            <footer class="SDAdminVerifyModal__footer">
                <button type="button" class="SDAdminVerifyModal__button SDAdminVerifyModal__button--ghost" data-action="resend">Reenviar código</button>
                <div>
                    <button type="button" class="SDAdminVerifyModal__button SDAdminVerifyModal__button--ghost" data-action="cancel">Cancelar</button>
                    <button type="button" class="SDAdminVerifyModal__button SDAdminVerifyModal__button--primary" data-action="verify">Verificar y continuar</button>
                </div>
            </footer>
        </section>`;

    document.body.appendChild(overlay);
    document.body.classList.add('SDAdminVerifyLock');

    const input = overlay.querySelector('input');
    const error = overlay.querySelector('.SDAdminVerifyModal__error');
    const verify = overlay.querySelector('[data-action="verify"]');
    const resend = overlay.querySelector('[data-action="resend"]');
    const cancel = overlay.querySelector('[data-action="cancel"]');
    const close = overlay.querySelector('.SDAdminVerifyModal__close');

    const destroy = () => {
        document.body.classList.remove('SDAdminVerifyLock');
        overlay.remove();
    };

    const setLoading = (value) => {
        verify.disabled = value;
        resend.disabled = value;
        cancel.disabled = value;
        input.disabled = value;
        verify.textContent = value ? 'Verificando...' : 'Verificar y continuar';
    };

    const cancelModal = () => {
        destroy();
        onCancel?.();
    };

    cancel.addEventListener('click', cancelModal);
    close.addEventListener('click', cancelModal);
    overlay.addEventListener('mousedown', (event) => {
        if (event.target === overlay) cancelModal();
    });

    input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        error.textContent = '';
    });
    input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') verify.click();
    });

    resend.addEventListener('click', async () => {
        error.textContent = '';
        resend.disabled = true;
        const original = resend.textContent;
        resend.textContent = 'Enviando...';
        try {
            const nextRecipient = await onResend?.();
            if (nextRecipient) overlay.querySelector('.SDAdminVerifyModal__notice span').textContent = nextRecipient;
            input.value = '';
            input.focus();
        } catch (err) {
            error.textContent = normalizedError(err, 'No se pudo reenviar el código.');
        } finally {
            resend.disabled = false;
            resend.textContent = original;
        }
    });

    verify.addEventListener('click', async () => {
        const code = input.value.trim();
        if (!/^\d{6}$/.test(code)) {
            error.textContent = 'Ingresá los 6 dígitos enviados a tu correo.';
            input.focus();
            return;
        }
        setLoading(true);
        error.textContent = '';
        try {
            const token = await onVerify(code);
            destroy();
            onCancel = null;
            overlay.__resolve?.(token);
        } catch (err) {
            setLoading(false);
            error.textContent = normalizedError(err, 'El código no es válido.');
            input.select();
        }
    });

    setTimeout(() => input.focus(), 50);
    return overlay;
};

const beginVerification = async ({ method, resource }) => {
    const action = actionLabel(method, resource);
    let challengeId = null;
    let recipient = null;

    const requestCode = async () => {
        const response = await API_CONNECT.post(REQUEST_URL, {
            actionMethod: String(method || '').toUpperCase(),
            actionPath: String(resource || ''),
            actionLabel: action,
        });
        const data = response?.data?.data || response?.data || {};
        if (data.verificationRequired === false) return { skip: true, recipient: null };
        challengeId = data.challengeId;
        recipient = data.recipient;
        if (!challengeId) throw new Error('No se pudo iniciar la verificación.');
        REACT_HOT_TOAST_SUCCESS('Código de acción enviado al correo.', { id: 'admin-action-code-sent', duration: 4500 });
        return { skip: false, recipient };
    };

    const initial = await requestCode();
    if (initial?.skip) return false;

    return new Promise((resolve) => {
        const modal = createModal({
            recipient,
            action,
            onResend: async () => (await requestCode())?.recipient,
            onVerify: async (code) => {
                const response = await API_CONNECT.post(VERIFY_URL, { challengeId, code });
                const data = response?.data?.data || response?.data || {};
                if (!data.actionToken) throw new Error('No recibimos la autorización de seguridad.');
                return data.actionToken;
            },
            onCancel: () => resolve(null),
        });
        modal.__resolve = resolve;
    });
};

export const ADMIN_ACTION_VERIFICATION = {
    isProtectedResource,
    async requestToken({ method, resource }) {
        if (!isProtectedResource(resource)) return null;
        if (activePromise) return activePromise;
        activePromise = beginVerification({ method, resource })
            .finally(() => { activePromise = null; });
        return activePromise;
    },
};
